<template>
  <div class="d-flex flex-column">
    <WorkersSelection
      :isLoading="isLoading"
      :showValidationErrors="showValidationErrors"
      :preventSelecting="preventSelecting"
      :workers="workers"
      @handleSelectedWorkers="handleSelectedWorkers"
      @unselectWorker="unselectWorker"
      :selectedWorkers="selectedWorkers"
      :isCandidates="isCandidates"
    />
    <slot />
    <div v-if="isLoading">
      <v-skeleton-loader v-for="i in 5" :key="i" type="list-item-avatar" />
    </div>
    <div class="overflow-auto" v-else>
      <div
        v-for="(worker, index) in unselectedWorkers"
        :key="index"
        @click="!preventSelecting && selectWorker(worker)"
        class="workers-select-item"
        :class="{ disabled: preventSelecting }"
      >
        <v-icon x-large class="icon-wrapper">mdi-account</v-icon>
        <div class="font-weight-regular">
          {{ worker.fullName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkersSelection from "@/components/bookings/WorkersSelection";
import { filter, forEach, includes, size, find } from "lodash";

export default {
  name: "SelectWorkers",
  components: {
    WorkersSelection
  },
  data() {
    return {
      selectedWorkers: []
    };
  },
  computed: {
    unselectedWorkers() {
      return filter(
        this.workers,
        ({ id }) => !find(this.selectedWorkers, { id })
      );
    }
  },
  props: {
    showValidationErrors: Boolean,
    preventSelecting: Boolean,
    workers: Array,
    isLoading: Boolean,
    initialSelectedWorkers: Array,
    isCandidates: Boolean
  },
  methods: {
    handleSelectedWorkers(selectedWorkersIds) {
      this.selectedWorkers = [];
      forEach(this.workers, worker => {
        if (includes(selectedWorkersIds, worker.id)) {
          this.selectedWorkers = [...this.selectedWorkers, worker];
        }
      });
      this.emitChanges();
    },
    unselectWorker(selectedWorker) {
      this.selectedWorkers = filter(
        this.selectedWorkers,
        worker => worker.id !== selectedWorker.id
      );
      this.emitChanges();
    },
    selectWorker(selectedWorker) {
      this.selectedWorkers = [...this.selectedWorkers, selectedWorker];
      this.emitChanges();
    },
    emitChanges() {
      this.$emit("change", this.selectedWorkers);
    }
  },
  watch: {
    initialSelectedWorkers(newValue) {
      if (size(newValue)) {
        this.selectedWorkers = [...newValue];
      }
    }
  }
};
</script>

<style lang="scss">
.workers-select-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 4px;

  .icon-wrapper {
    background-color: rgba(94, 122, 141, 0.1);
    padding: 6px 8px;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    margin-right: 14px;
  }

  &.disabled {
    cursor: default;
    color: $secondary-line !important;
  }

  &:not(.disabled) {
    &:hover {
      background-color: rgba(94, 122, 141, 0.1);
    }
  }
  &:not(:last-child) {
    border-bottom: 1px solid $secondary-line;
  }
}
</style>
